module.exports = __webpack_public_path__ + "img/swoosh-sm.a1127802.png";